import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./BolliniVerdiActions";
import { BollinoDto } from "../generated";

class InterventiStore extends AbstractLookupStore<BollinoDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getByImpianto, ({ idImpianto, bolliniVerdi }) => this.set(idImpianto.toString(), bolliniVerdi!))
            .onfunction(Actions.add, bollinoVerde => {
                if (!bollinoVerde)
                    return;
                const byImpianto = this.get(bollinoVerde.idImpianto.toString());
                if (!byImpianto)
                    return;
                this.set(bollinoVerde.idImpianto.toString(), [...byImpianto, bollinoVerde]);
            })
            .onfunction(Actions.update, bollinoVerde => {
                if (!bollinoVerde)
                    return;
                const byImpianto = this.get(bollinoVerde.idImpianto.toString());
                if (!byImpianto)
                    return;
                const index = byImpianto.findIndex(x => x.idBollino == bollinoVerde.idBollino);

                this.set(bollinoVerde.idImpianto.toString(), [
                    ...byImpianto.slice(0, index),
                    bollinoVerde,
                    ...byImpianto.slice(index + 1)
                ]
                );
            })
            .onfunction(Actions.delete, (result) => {
                if (result == null) return;
                const byImpianto = this.get(result.idImpinato.toString());
                if (!byImpianto)
                    return;
                const index = byImpianto.findIndex(x => x.idBollino == result.idBollino);
                byImpianto.splice(index, 1)
                this.set(result.idImpinato.toString(), [...byImpianto]);
            })
            ;
    }
    public useForImpianto = (idImpianto: number) => {
        return this.useStoreWithAction(
            idImpianto.toString(),
            idImpianto => Actions.getByImpianto(parseInt(idImpianto)),
            x => -x.validity.to.valueOf()
        );
    }
}

export default new InterventiStore()
